import { render, staticRenderFns } from "./DeviceTokenDialog.vue?vue&type=template&id=0824a0a9&scoped=true"
import script from "./DeviceTokenDialog.vue?vue&type=script&lang=js"
export * from "./DeviceTokenDialog.vue?vue&type=script&lang=js"
import style0 from "./DeviceTokenDialog.vue?vue&type=style&index=0&id=0824a0a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0824a0a9",
  null
  
)

export default component.exports